<template>
	<transition
			name="custom-classes-transition" 
			:enter-active-class="$_verInfFt_styleComponentAnimation()">
		<template v-if="$_verInfFt_stateComponentIsInitialized">
			<v-footer
					app
					:color="$_verInfFt_styleFooterColor"
					:dark="$_verInfFt_styleFooterDark"
					:light="$_verInfFt_styleFooterLight">
				<v-row no-gutters justify="center">
					<v-col cols="auto">
						<v-dialog>
							<template v-slot:activator="{ on }">
								<v-btn	class="customVBtn"
										:block="$_verInfFt_styleVersionButtonBlock"
										:color="$_verInfFt_styleVersionButtonColor"
										:dark="$_verInfFt_styleVersionButtonDark"
										:depressed="$_verInfFt_styleVersionButtonDepressed"
										:elevation="$_verInfFt_styleVersionButtonElevation"
										:large="$_verInfFt_styleVersionButtonLarge"
										:light="$_verInfFt_styleVersionButtonLight"
										:outlined="$_verInfFt_styleVersionButtonOutlined"
										:rounded="$_verInfFt_styleVersionButtonRounded"
										:small="$_verInfFt_styleVersionButtonSmall"
										:text="$_verInfFt_styleVersionButtonFlat"
										v-on="on">
									<span class="overline" v-text="appVersion" />
								</v-btn>
							</template>
							<v-card	class="customVCard">
								<v-row class="px-2 pt-2">
									<v-col>
										<template v-for="(versionVals, versionKey) in sortObject($_verInfFt_stateVersionInfo, 'version', 'desc')">
											<v-alert
													:key="versionKey"
													outlined
													border="left"
													colored-border>
												<v-row class="px-1" align="center">
													<v-col cols="12" md="2">
														<span class="body-2" v-text="versionVals.version" />
													</v-col>
													<v-col>
														<v-expansion-panels flat>
															<v-expansion-panel>
																<v-expansion-panel-header>
																	<span class="body-2" v-html="versionVals.summary" />
																</v-expansion-panel-header>
																<v-expansion-panel-content>
																	<v-row class="mt-6" no-gutters>
																		<v-col>
																			<template v-if="!isEmpty(versionVals.description)">
																				<v-row dense>
																					<v-col>
																						<v-alert
																								class="customVAlert"
																								icon="description"
																								prominent
																								text
																								type="info">
																							<span	class="markdown"
																									v-html="marked(versionVals.description.join('\n'))" />
																						</v-alert>
																					</v-col>
																				</v-row>
																			</template>
																			<template v-if="!isEmpty(versionVals.relatedTestSuite)">
																				<v-row dense>
																					<v-col>
																						<v-alert
																								class="customVAlert"
																								icon="fact_check"
																								prominent
																								text
																								type="error">
																							<span	class="markdown"
																									v-html="marked(versionVals.relatedTestSuite.join('\n'))" />
																						</v-alert>
																					</v-col>
																				</v-row>
																			</template>
																			<template v-if="isEmpty(versionVals.description) && isEmpty(versionVals.relatedTestSuite)">
																				<v-row dense>
																					<v-col>
																						<v-alert
																								class="customVAlert"
																								color="secondary"
																								text>
																							<span class="body-2">No detail information</span>
																						</v-alert>
																					</v-col>
																				</v-row>
																			</template>
																		</v-col>
																	</v-row>
																</v-expansion-panel-content>
															</v-expansion-panel>
														</v-expansion-panels>
													</v-col>
													<v-col cols="12" md="auto">
														<span class="body-2" v-text="formatDate(versionVals.date, 'dddd, MMMM Do YYYY')" />
													</v-col>
												</v-row>
											</v-alert>
										</template>
									</v-col>
								</v-row>
							</v-card>
						</v-dialog>
					</v-col>
				</v-row>
			</v-footer>
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'VersionInfoFooter',
		data() {
			return {
				componentName_: 'versionInfoFooter'
			}
		},
		computed: {
			// state
			$_verInfFt_stateVersionInfo() {
				const self_ = this;
				return self_.getVersionInfoState()
			},
			// state
			$_verInfFt_stateComponentIsInitialized() {
				const self_ = this;
				return self_.getComponentState('isInitialized')
			},
			// contents / inits
			$_verInfFt_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getComponentContents(self_.componentName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_verInfFt_inits() {
				const self_ = this;
				return () => {
					return self_.getComponentInits(self_.componentName_)
				}
			},
			// style
			$_verInfFt_styleComponent() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.$_verInfFt_inits())) { return null }
					return self_.getInitsStyleVal(self_.$_verInfFt_inits(), 'component')
				}
			},
			$_verInfFt_styleComponentAnimation() {
				const self_ = this;
				return () => {
					const component_ = self_.$_verInfFt_styleComponent()
					if(self_.isFalse(component_)) { return null }
					return self_.getStylesVal(component_.animation)
				}
			},
			$_verInfFt_styleFooter() {
				const self_ = this;
				if(self_.isEmpty(self_.$_verInfFt_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_verInfFt_inits(), 'footer')
			},
			$_verInfFt_styleFooterColor() {
				const self_ = this;
				const footer_ = self_.$_verInfFt_styleFooter;
				if(self_.isFalse(footer_)) { return null }
				return self_.getStylesVal(footer_.color)
			},
			$_verInfFt_styleFooterDark() {
				const self_ = this;
				const footer_ = self_.$_verInfFt_styleFooter;
				if(self_.isFalse(footer_)) { return null }
				return self_.getStylesVal(footer_.dark)
			},
			$_verInfFt_styleFooterLight() {
				const self_ = this;
				const footer_ = self_.$_verInfFt_styleFooter;
				if(self_.isFalse(footer_)) { return null }
				return self_.getStylesVal(footer_.light)
			},
			$_verInfFt_styleVersionButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_verInfFt_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_verInfFt_inits(), 'versionButton')
			},
			$_verInfFt_styleVersionButtonBlock() {
				const self_ = this;
				const button_ = self_.$_verInfFt_styleVersionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_verInfFt_styleVersionButtonColor() {
				const self_ = this;
				const button_ = self_.$_verInfFt_styleVersionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_verInfFt_styleVersionButtonDark() {
				const self_ = this;
				const button_ = self_.$_verInfFt_styleVersionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_verInfFt_styleVersionButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_verInfFt_styleVersionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_verInfFt_styleVersionButtonElevation() {
				const self_ = this;
				const button_ = self_.$_verInfFt_styleVersionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_verInfFt_styleVersionButtonFlat() {
				const self_ = this;
				const button_ = self_.$_verInfFt_styleVersionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_verInfFt_styleVersionButtonLarge() {
				const self_ = this;
				const button_ = self_.$_verInfFt_styleVersionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_verInfFt_styleVersionButtonLight() {
				const self_ = this;
				const button_ = self_.$_verInfFt_styleVersionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_verInfFt_styleVersionButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_verInfFt_styleVersionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_verInfFt_styleVersionButtonRounded() {
				const self_ = this;
				const button_ = self_.$_verInfFt_styleVersionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_verInfFt_styleVersionButtonSmall() {
				const self_ = this;
				const button_ = self_.$_verInfFt_styleVersionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			}
		}
	}
</script>

<style scoped>
</style>
